import { Modal, Table } from "react-bootstrap";
import { CampaignRecipient } from "../../../features/campaign/campaignTypes";
import { formatCampaignMobile } from "./newCampaignFormConfig";
import { formatEventDateMd, ScheduledRecipientRow } from "../campaignUtils";

interface ScheduledThisMonthModalProps {
  show: boolean;
  monthLabel: string;
  campaignName?: string;
  rows: ScheduledRecipientRow[];
  onHide: () => void;
}

const ScheduledThisMonthModal = ({
  show,
  monthLabel,
  campaignName,
  rows,
  onHide,
}: ScheduledThisMonthModalProps) => {
  const showCampaign = !campaignName;
  const title = campaignName
    ? `${campaignName} · ${monthLabel}`
    : `Scheduled · ${monthLabel}`;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px", fontWeight: 600, color: "#19222E" }}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        {rows.length === 0 ? (
          <p className="text-muted mb-0" style={{ padding: "24px" }}>
            No recipients are scheduled this month.
          </p>
        ) : (
          <div style={{ maxHeight: "70vh", overflow: "auto" }}>
            <Table hover className="mb-0" style={{ fontSize: "13px" }}>
              <thead
                className="table-light"
                style={{ position: "sticky", top: 0, zIndex: 1 }}
              >
                <tr>
                  <th style={{ width: 88, whiteSpace: "nowrap" }}>Event date</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th style={{ whiteSpace: "nowrap" }}>Mobile</th>
                  {showCampaign && <th>Campaign</th>}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => {
                  const recipient: CampaignRecipient = row.recipient;
                  return (
                    <tr key={recipient.recipient_id || `${row.campaignId}-${index}`}>
                      <td style={{ fontWeight: 600, color: "#19222E", whiteSpace: "nowrap" }}>
                        {formatEventDateMd(recipient.event_date)}
                      </td>
                      <td style={{ color: "#19222E" }}>{recipient.name || "—"}</td>
                      <td style={{ color: "#495057" }}>{recipient.email || "—"}</td>
                      <td style={{ color: "#495057", whiteSpace: "nowrap" }}>
                        {recipient.mobile?.trim()
                          ? formatCampaignMobile(recipient.mobile)
                          : "—"}
                      </td>
                      {showCampaign && (
                        <td style={{ color: "#495057" }}>{row.campaignName}</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ScheduledThisMonthModal;
